<template>
  <v-container fluid class="pa-0">
    <v-row align="center" justify="space-between" class="mb-4" v-if="!expand">
      <v-col cols="12">
        <div class="d-flex justify-space-between">
          <div>
            <div class="text-h4 font-weight-bold">Partner Organizations</div>
            <div class="text-subtitle-2">
              <span class="text-grey">View and Manage Host Establishments</span>
            </div>
          </div>
          <div class="d-flex justify-end align-center">
            <v-btn
              class="white--text"
              color="#00A63E"
              @click="addnew"
              prepend-icon="mdi-plus"
              rounded
            >
              Add Partner
            </v-btn>
          </div>
        </div>
      </v-col>
      <v-col cols="12" class="">
        <div class="pa-4 elevation-1">
          <v-text-field
            v-model="search"
            label="Search..."
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="mr-2"
            color="primary"
          />
        </div>
      </v-col>
    </v-row>

    <v-expand-x-transition>
      <v-row v-if="!expand">
        <v-col cols="4" v-for="i in data" :key="i.id">
          <v-card class="rounded-lg elevation-2" max-width="504" hover>
            <div
              style="height: 150px; background-color: #f0fdf4"
              class="d-flex justify-center align-center"
            >
              <div class="text-h2 font-weight-bold" style="color: #b9f8cf">
                {{ i.name[0].toUpperCase() }}
              </div>
            </div>
            <v-card-item>
              <v-card-title
                ><div class="d-flex justify-space-between align-center">
                  <div class="text-subtitle-1 font-weight-bold">
                    {{ i.name }}
                  </div>
                  <div>
                    <v-chip color="#008236" size="small">Active</v-chip>
                  </div>
                </div>
              </v-card-title>

              <v-card-subtitle
                ><v-icon>mdi-map-marker-radius</v-icon> {{ i.address }}
              </v-card-subtitle>
              <v-card-subtitle
                ><v-icon>mdi-account</v-icon> {{ i.contact_person }}
              </v-card-subtitle>
            </v-card-item>

            <v-card-text>
              <v-divider></v-divider>
              <div class="d-flex justify-space-between align-center mt-4">
                <div class="text-body-2 text-grey">5 Slots Available</div>
                <div
                  class="text-body-2"
                  style="color: #00a63e"
                  @click="viewDetails(i)"
                >
                  View Details
                  <v-icon size="small">mdi-feature-search-outline</v-icon>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="expand">
        <v-col cols="12" style="background-color: white; height: 80vh">
          <div>
            <div
              @click="expand = !expand"
              color="text-grey "
              class="d-flex justify-start align-center text-subtitle-2 cursor-pointer"
            >
              <div><v-icon>mdi-chevron-left</v-icon></div>
              <div>Back to List</div>
            </div>
            <div class="d-flex justify-space-between mt-6">
              <div class="d-flex">
                <div
                  class="text-h4 font-weight-bold d-flex justify-center align-center rounded-lg"
                  style="
                    color: #10b981;
                    width: 75px;
                    height: 75px;
                    background-color: #10b9811a;
                  "
                >
                  {{ orgData.name[0].toUpperCase() }}
                </div>
                &nbsp;&nbsp;
                <div>
                  <div class="text-h4 font-weight-bold">{{ orgData.name }}</div>
                  <div class="text-subtitle-2 text-grey">
                    {{ orgData.description }}
                  </div>
                </div>
              </div>

              <div
                class="elevation-1 rounded-lg d-flex justify-center align-center"
                style="width: 130px; height: 75px"
              >
                <div>
                  <center>
                    <div class="text-h5 my-2" style="color: #10b981">
                      {{ orgData.slots }}
                    </div>
                    <div class="text-uppercase text-subtitle-2 text-grey">
                      Available slots
                    </div>
                  </center>
                </div>
              </div>
            </div>

            <div class="d-flex justify-space-between">
              <div
                class="rounded-lg px-10 py-5 elevation-2 mt-4"
                style="width: 33%; height: 400px"
              >
                <div class="d-flex align-center">
                  <v-icon color="#10B981">mdi-domain</v-icon>&nbsp;&nbsp;&nbsp;
                  <div class="text-h5">Contact Information</div>
                </div>
                <div class="my-3 text-grey">
                  <div class="text-caption">Contact Person</div>
                  <div class="d-flex align-center">
                    <v-icon color="grey">mdi-account</v-icon>&nbsp;&nbsp;&nbsp;
                    <div class="text-subtitle-1">
                      {{ orgData.contact_person }}
                    </div>
                  </div>
                </div>
                <div class="my-3 text-grey">
                  <div class="text-caption">Email Address</div>
                  <div class="d-flex align-center">
                    <v-icon color="grey">mdi-email-outline</v-icon
                    >&nbsp;&nbsp;&nbsp;
                    <div class="text-subtitle-1">
                      {{ orgData.email }}
                    </div>
                  </div>
                </div>
                <div class="my-3 text-grey">
                  <div class="text-caption">Phone Number</div>
                  <div class="d-flex align-center">
                    <v-icon color="grey">mdi-phone</v-icon>&nbsp;&nbsp;&nbsp;
                    <div class="text-subtitle-1">
                      {{ orgData.phone_no }}
                    </div>
                  </div>
                </div>
                <div class="my-3 text-grey">
                  <div class="text-caption">Address</div>
                  <div class="d-flex align-center">
                    <v-icon color="grey">mdi-map-marker</v-icon
                    >&nbsp;&nbsp;&nbsp;
                    <div class="text-subtitle-1">
                      {{ orgData.address }}
                    </div>
                  </div>
                </div>
                <div class="my-3 text-grey">
                  <div class="text-caption">Website</div>
                  <div class="d-flex align-center">
                    <v-icon color="grey">mdi-web</v-icon>&nbsp;&nbsp;&nbsp;
                    <div class="text-subtitle-1">
                      {{ orgData.website }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="rounded-lg px-10 py-5 elevation-2 mt-4"
                style="width: 65%"
              >
                <div class="d-flex align-center">
                  <v-icon color="#10B981">mdi-account-multiple</v-icon
                  >&nbsp;&nbsp;&nbsp;
                  <div class="text-h5">Active Interns</div>
                </div>
                <v-divider></v-divider>
                <div style="height: 600px; overflow-y: auto">
                  <div v-for="(i, index) in 10" :key="index">
                    <div class="my-4 d-flex align-center">
                      <div
                        class="text-subtitle-1 d-flex justify-center align-center text-grey"
                        style="
                          width: 30px;
                          height: 30px;
                          border-radius: 100%;
                          background-color: #e2e8f0;
                        "
                      >
                        S1
                      </div>
                      <div class="ml-4">
                        <div class="text-subtitle-1 font-weight-bold">
                          Student {{ index + 1 }}
                        </div>
                        <div class="text-caption text-grey">
                          BSIT - Started Jan 2026
                        </div>
                      </div>
                    </div>
                    <v-divider></v-divider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12"> </v-col>
      </v-row>
    </v-expand-x-transition>

    <!-- Dialogs -->
    <!-- <OJTOrgsDialog :data="itemData" :action="action" />
    <OrgCriteriaWeightsDialog :data="viewData" />
    <ManageCredentialsDialog :data="creds" /> -->

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </v-container>
</template>

<script>
// import eventBus from "@/eventBus";
// import OJTOrgsDialog from "../../components/Dialogs/Forms/OJTOrgsDialog.vue";
// import OrgCriteriaWeightsDialog from "../Dialogs/Forms/OrgCriteriaWeightsDialog.vue";
// import ManageCredentialsDialog from "../Dialogs/Forms/Organization/ManageCredentialsDialog.vue";

export default {
  components: {
    // OJTOrgsDialog,
    // OrgCriteriaWeightsDialog,
    // ManageCredentialsDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    expand: false,
    search: "",
    headers: [
      { title: "Name", value: "name", align: "start" },
      { title: "Address", value: "address", align: "start" },
      //   { title: "Program Tied", value: "program_tied", align: "start" },

      {
        title: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 200,
      },
    ],
    data: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    totalCount: 0,
    deleteData: null,
    itemData: null,
    viewData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    creds: null,
    orgData: null,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.initialize();
    // eventBus.on("closeOJTOrgsDialog", () => {
    //   this.initialize();
    // });
    // eventBus.on("closeOrgCriteriaWeightsDialog", () => {
    //   this.initialize();
    // });
    // eventBus.on("closeManageCredentialsDialog", () => {
    //   this.initialize();
    // });
  },
  beforeUnmount() {
    // eventBus.off("closeOJTOrgsDialog");
    // eventBus.off("closeOrgCriteriaWeightsDialog");
    // eventBus.off("closeManageCredentialsDialog");
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {
      this.loading = true;
      this.axiosCall("/organization/student/tiedByInstitute", "GET").then(
        (res) => {
          if (res) {
            this.data = res.data;
            this.loading = false;
          }
        },
      );
    },
    addnew() {
      this.itemData = [{ id: null }];
      this.action = "Add";
    },
    // deleteItem(item) {
    //   console.log(item);
    //   this.alerted = true;
    //   // this.dialogConfirmDelete = true;
    //   // this.deleteData = item;
    // },
    editItem(item) {
      this.itemData = item;
      this.action = "Update";
    },

    viewItem(item) {
      this.viewData = item;
    },

    viewDetails(item) {
      this.expand = !this.expand;
      this.orgData = item;
    },

    manageItem(item) {
      this.creds = item;
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },
  },
};
</script>
<style scoped>
.bg {
  background-color: rgb(242, 255, 240);
}
</style>
